module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    staticClass: "ControlNav",
    attrs: {
      "fixed": "top"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar-nav', [_c('b-nav-item', {
    class: [{
      active: _vm.onAccountTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/account"
    }
  }, [_c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v("Account ")]), _vm._v("Home"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Settings, Billing, Contacts")])]), _vm._v(" "), _c('b-nav-item', {
    class: [{
      disabled: true,
      active: _vm.onServicesTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/services"
    }
  }, [_vm._v("\n        Services"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Servers, Hosting, etc.")])]), _vm._v(" "), _c('b-nav-item', {
    class: [{
      disabled: !_vm.hasPaymentsViewPerm,
      active: _vm.onBillingTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/billing"
    }
  }, [_vm._v("\n        Billing"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Payments, Statements")])])], 1), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-item', {
    class: ['CtrLogout', 'control-logout'],
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('b-icon-box-arrow-right', {
    staticClass: "hide-mobile",
    attrs: {
      "font-scale": "1.25",
      "id": "logout-icon"
    }
  }), _c('span', {
    staticClass: "nav-info logout-button-span"
  }, [_vm._v("Log Out")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-454a5836","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomNavbar.vue
// module id = 1320
// module chunks = 16